import { AbstractAdapter } from '@shared/helpers/abstract.adapter';
import { BlogAuthor, BlogAuthorAdapter } from './blog-author.model';
import { BlogCategory, BlogCategoryAdapter } from './blog-category.model';
import { DatePipe } from '@angular/common';
import { IArticle, ITag } from '@shared/interfaces/IArticle.interface';
import { Injectable } from '@angular/core';

export class BlogArticle implements IArticle {
  id: string;
  slug: string;
  heroImageUrl: string;
  title: string;
  description: string;
  summary: string;
  readTime: string;
  content: string;
  tags: string;
  status: string;
  publishDate: string;
  author: BlogAuthor;
  category: BlogCategory;
  authorId: string;
  categoryId: string;
  created: string;
  createdBy: string;
  modified: string;
  modifiedBy: string;
  linkedArticleUrl: string;
  hashes: ITag[];
}

@Injectable({
  providedIn: 'root'
})
export class BlogArticleAdapter extends AbstractAdapter {
  private mapper = {
    id: {},
    slug: {},
    heroImageUrl: {},
    title: {},
    description: {},
    summary: {},
    readTime: {},
    content: {},
    tags: {},
    status: {},
    publishDate: {},
    author: {},
    category: {},
    authorId: {},
    categoryId: {},
    created: {},
    createdBy: {},
    modified: {},
    modifiedBy: {},
    linkedArticleUrl: {}
  };

  constructor(
    private authorAdapter: BlogAuthorAdapter,
    private categoryAdapter: BlogCategoryAdapter,
    private datePipe: DatePipe
  ) {
    super();
    this.mapper['author']['adapter'] = this.authorAdapter;
    this.mapper['category']['adapter'] = this.categoryAdapter;
  }

  adapt(item: any, mapper?: unknown): BlogArticle {
    const article = new BlogArticle();
    const adaptMapper = (typeof mapper === 'object') ? mapper : this.mapper;
    super.processMapping(adaptMapper, item, article);
    let publishDate: any = new Date(article.publishDate.substr(0, 10));
    // eslint-disable-next-line eqeqeq
    if (publishDate == 'Invalid Date') {
      publishDate = new Date();
    }
    article.publishDate = this.datePipe.transform(publishDate, 'MMM d, y');
    article['hashes'] = this.tagsToHash(article.tags);

    return article;
  }

  private tagsToHash(tags: string): ITag[] {
    const hashes = [];
    const tagsArr = tags.split(' ');
    tagsArr.forEach((tag) => {
      const hash = '#' + tag.replace(/[^a-zA-Z0-9-]/g, ' ');
      hashes.push({
        tag,
        hash
      });
    });
    return hashes;
  }
}
